import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, timeAgo } from "@/lib/api";
import { Avatar, Spinner } from "@/components/common";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { REACTION, REACTIONS } from "@/components/Reactions";

// Who reacted, with a tab per reaction that has any.
export const Appreciations = ({ url, id, open, setOpen }) => {
  const [rows, setRows] = useState(null);
  const [tab, setTab] = useState("all");
  useEffect(() => { if (open) { setRows(null); setTab("all"); api.get(url).then((r) => setRows(r.data)).catch(() => setRows([])); } }, [open, url]);
  const used = REACTIONS.filter((r) => (rows || []).some((u) => u.type === r.id));
  const shown = (rows || []).filter((u) => tab === "all" || u.type === tab);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm" data-testid={`appreciations-dialog-${id}`}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-medium">Reactions</DialogTitle>
          <DialogDescription>People who reacted to this.</DialogDescription>
        </DialogHeader>
        {used.length > 1 && (
          <div className="flex flex-wrap gap-1" data-testid="reactions-tabs">
            {[{ id: "all", label: "All" }, ...used].map((r) => (
              <button key={r.id} type="button" onClick={() => setTab(r.id)} data-testid={`reactions-tab-${r.id}`}
                className={`rounded-full px-3 py-1 text-xs transition-colors ${tab === r.id ? "bg-slate-900 text-white" : "bg-black/5 hover:bg-black/10"}`}>{r.emoji ? `${r.emoji} ${(rows || []).filter((u) => u.type === r.id).length}` : r.label}</button>
            ))}
          </div>)}
        {rows === null ? <Spinner /> : rows.length === 0 ? <p className="text-sm text-slate-500" data-testid="appreciations-empty">Nobody yet.</p> : (
          <ul className="max-h-80 space-y-1 overflow-y-auto" data-testid="appreciations-list">
            {shown.map((u) => (
              <li key={u.user_id}>
                <Link to={`/u/${u.user_id}`} onClick={() => setOpen(false)} className="flex items-center gap-3 rounded-xl p-2 transition-colors hover:bg-black/5" data-testid={`appreciation-user-${u.user_id}`}>
                  <span className="relative"><Avatar user={u} size={34} /><span className="absolute -bottom-1 -right-1 text-sm" title={REACTION[u.type]?.label}>{REACTION[u.type]?.emoji}</span></span>
                  <span className="min-w-0 flex-1"><span className="block truncate text-sm font-medium">{u.name}</span>{u.handle && <span className="block truncate text-xs text-slate-500">@{u.handle}</span>}</span>
                  <span className="text-[11px] text-slate-400">{timeAgo(u.at)}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
